module.exports = {"sld:ColorMapEntry":[{"color":"#0074ad","label":"< 2.01657","quantity":0.02017},{"color":"#9dc4b5","label":" 2.01657- 2.3167","quantity":0.02317},{"color":"#e6efc3","label":" 2.3167- 2.72444","quantity":0.02724},{"color":"#ffe89e","label":" 2.72444- 3.54975","quantity":0.0355},{"color":"#f5af7f","label":" 3.54975- 5.11168","quantity":0.05112},{"color":"#ed6d32","label":" 5.11168- 20.8878","quantity":0.20888}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/fxfl_raster/rice_MME_1981_2016_lcr_90_return_20.json
// module id = kJnK
// module chunks = 171